import { JobsPage } from '@/admin-design/_common/jobs'

const labels = {
  session_purge: 'Session purge',
}

export default function Jobs() {
  return <JobsPage labels={labels} />
}
